import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { lego } from '@zz-common/lego';
import { request } from "./ajax";
import { getUrlParams, addQuery } from "./util";
export var defaultUrl = 'https://m.zhuanzhuan.com/system/kf_center/HomePage';
var baseUrl = 'https://m.zhuanzhuan.com/system/zzappimservice/index.html';
var apiUrl = 'https://app.zhuanzhuan.com/api/kf_entry_manager/get-entry-url';
var getKeyName = function getKeyName(link) {
  var _exec;
  return ((_exec = /\/(\w+)(\?|\/\?)/ig.exec(link)) === null || _exec === void 0 ? void 0 : _exec[1]) || '';
};
var isFeentryUrl = function isFeentryUrl(link) {
  var keyName = getKeyName(link);
  var params = getUrlParams(link);
  return /feentry.zhuanzhuan.com/gi.test(link) && keyName && (params === null || params === void 0 ? void 0 : params.clientid);
};
var PAGETYPE = 'SENTRY_ADATPER_SENDCODE';
var ACTIONTYPE = {
  SUCCESS: 'SENTRY_ADATPER_SENDCODE_SUCCESS',
  FAIL: 'SENTRY_ADATPER_SENDCODE_FAIL',
  ERROR: 'SENTRY_ADATPER_SENDCODE_ERROR'
};
var sendLego = function sendLego() {
  var actiontype = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var backup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  lego.send({
    pagetype: PAGETYPE,
    actiontype: actiontype || ACTIONTYPE.SUCCESS,
    backup: backup
  }, function () {}, true);
};
function removeEmptyValues() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    for (var key in obj) {
      if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        delete obj[key];
      }
    }
    return obj;
  } catch (e) {
    console.log(e);
  }
  return {};
}
var getPrerenderResultUrl = function getPrerenderResultUrl(resUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var legoBackup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var resParams = getUrlParams(resUrl);
  var oldParams = removeEmptyValues(params || {}) || {};
  var currParams = removeEmptyValues(resParams || {}) || {};
  var mergeParams = _objectSpread(_objectSpread({}, oldParams || {}), currParams);
  if (resUrl && /system\/zzappimservice/gi.test(resUrl)) {
    var _targetUrl = addQuery(baseUrl, _objectSpread(_objectSpread({}, mergeParams), {}, {
      needHideHead: 3
    }));
    var resultUrl = _targetUrl + '#/prerender/NewHome';
    sendLego(ACTIONTYPE.SUCCESS, _objectSpread(_objectSpread({
      type: 'imLink',
      resultUrl: resultUrl,
      resUrl: resUrl
    }, legoBackup), mergeParams));
    return resultUrl;
  }
  var targetUrl = addQuery(resUrl, mergeParams);
  sendLego(ACTIONTYPE.SUCCESS, _objectSpread(_objectSpread({
    type: 'otherLink',
    resUrl: resUrl,
    targetUrl: targetUrl
  }, legoBackup), params));
  return targetUrl;
};

// 判断是不是跳转客服im的链接
export var isKfImUrl = function isKfImUrl(link) {
  if (!link) return false;
  return isFeentryUrl(link) || /system\/zzappimservice/gi.test(link) || false;
};

// 客服im url： feentry.zhuanzhuan.com 类入口 需要获取原始链接再跳转
export var goToKfChat = function goToKfChat(link, callback) {
  try {
    if (!link) {
      sendLego(ACTIONTYPE.FAIL, {
        type: 'empty'
      });
      callback && callback(defaultUrl);
    }
    var params = getUrlParams(link);
    var keyName = getKeyName(link);
    if (isFeentryUrl(link)) {
      request({
        url: apiUrl,
        params: {
          urlName: keyName,
          clientId: params === null || params === void 0 ? void 0 : params.clientid
        },
        timeout: 300
      }).then(function (res) {
        var resUrl = (res === null || res === void 0 ? void 0 : res.respCode) === 0 ? (res === null || res === void 0 ? void 0 : res.respData) || link || defaultUrl : link;
        var resultUrl = getPrerenderResultUrl(resUrl, params, {
          link: link
        });
        callback && callback(resultUrl);
      }).catch(function (e) {
        sendLego(ACTIONTYPE.FAIL, _objectSpread({
          type: 'apicatch',
          keyName: keyName,
          link: link,
          errorInfo: JSON.stringify(e || {
            errMsg: 'apicatch error'
          })
        }, params));
        callback && callback(link);
      });
    } else {
      var resultUrl = getPrerenderResultUrl(link, params, {
        type: 'noFeentryUrl',
        link: link
      });
      callback && callback(resultUrl);
    }
  } catch (e) {
    sendLego(ACTIONTYPE.ERROR, {
      type: 'trycatch',
      link: link,
      errorInfo: JSON.stringify(e || {
        errMsg: 'trycatch error'
      })
    });
    callback && callback(link || defaultUrl);
  }
};